var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[_c('img',{staticClass:"object-cover h-full w-full",attrs:{"src":require("../../assets/images/map-img.webp"),"alt":"worldMap"}})])
}]

export { render, staticRenderFns }